<template>
    <section :id="slice.primary.anchorName || undefined" class="slice slice-criterias" aria-label="criterias">
        <div class="slice-content">
            <div
                class="criterias-panel"
                :class="{
                    'criterias-panel--bg': slice.primary.lightTealBackground,
                    'criterias-panel--two-cols': slice.items.length > 1,
                }"
            >
                <div class="criterias-panel__header">
                    <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" />
                    <PrismicImage v-if="slice.primary.image" :image="slice.primary.image" class="criterias-image" />
                </div>
                <div class="criterias-panel__body">
                    <div v-for="(item, i) in slice.items" :key="i" :item="item" class="criteria">
                        <div class="criteria-title">{{ item.title }}</div>
                        <PrismicRichText :field="item.text" :class="['criteria-text', {'criteria-text--teal': slice.primary.lightTealBackground}]" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {CriteriasSlice} from '@prismicio-types';
    import PrismicImage from '~/components/PrismicImage.vue';

    defineProps(getSliceComponentProps<CriteriasSlice>(['slice', 'index', 'slices', 'context']));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .criterias-panel {
        max-width: 1280px;
        border-radius: var(--joy-core-radius-4);
        padding: var(--joy-core-spacing-8) var(--joy-core-spacing-5);
        box-shadow: 0 var(--joy-core-spacing-1) var(--joy-core-spacing-5) 0 rgb(51 51 48 / 20%);
        background-color: var(--joy-color-neutral-20);

        .slice-title {
            font-size: var(--joy-font-size-secondary-200);
            margin-bottom: var(--joy-core-spacing-4);

            @include mq.screen_md(min) {
                font-size: var(--joy-font-size-secondary-400);
            }
        }

        &__header {
            margin-bottom: var(--joy-core-spacing-8);
        }

        @include mq.screen_md(min) {
            text-align: left;
            display: flex;
            padding: var(--joy-core-spacing-12) 80px;

            &__header {
                flex: none;
                margin-bottom: 0;
                width: 45%;
            }

            &__body {
                display: flex;
            }

            &--two-cols {
                .criteria {
                    flex: none;
                    width: 50%;
                }
            }
        }

        &--bg {
            background-color: var(--joy-color-secondary-10);
            box-shadow: none;
        }
    }

    .criteria {
        width: 100%;
        text-align: left;
        margin: 0 auto var(--joy-core-spacing-6);

        &-title {
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-primary-600);
            font-weight: var(--joy-font-weight-bold);
            color: var(--joy-color-neutral-60);
            margin-bottom: var(--joy-core-spacing-4);

            @include mq.screen_md(min) {
                font-size: var(--joy-font-size-primary-800);
            }
        }

        &-cta {
            margin-top: var(--joy-core-spacing-6);
        }

        &-text {
            li {
                list-style-type: none;
                padding-left: var(--joy-core-spacing-6);
                margin-bottom: var(--joy-core-spacing-3);
                background: url('./check-red.svg') no-repeat;
                background-position: left 3px;
            }

            &--teal {
                li {
                    background-image: url('./check-teal.svg');
                }
            }
        }

        @include mq.screen_md(min) {
            padding-left: var(--joy-core-spacing-8);
        }
    }
</style>
